import { FC } from "react";
import { IconPropsType } from ".";

export const CRMRequest: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 16H3C2.44772 16 2 16.4477 2 17V20C2 20.5523 2.44772 21 3 21H9C9.55229 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16ZM3 15C1.89543 15 1 15.8954 1 17V20C1 21.1046 1.89543 22 3 22H9C10.1046 22 11 21.1046 11 20V17C11 15.8954 10.1046 15 9 15H3Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4H3C2.44772 4 2 4.44772 2 5V8C2 8.55228 2.44772 9 3 9H9C9.55229 9 10 8.55228 10 8V5C10 4.44772 9.55228 4 9 4ZM3 3C1.89543 3 1 3.89543 1 5V8C1 9.10457 1.89543 10 3 10H9C10.1046 10 11 9.10457 11 8V5C11 3.89543 10.1046 3 9 3H3Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 10H16C15.4477 10 15 10.4477 15 11V14C15 14.5523 15.4477 15 16 15H22C22.5523 15 23 14.5523 23 14V11C23 10.4477 22.5523 10 22 10ZM16 9C14.8954 9 14 9.89543 14 11V14C14 15.1046 14.8954 16 16 16H22C23.1046 16 24 15.1046 24 14V11C24 9.89543 23.1046 9 22 9H16Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1465 4.14642L14.8536 4.85353L13.7072 5.99998H17.5001C18.263 5.99998 18.7881 6.32908 19.1058 6.77032C19.4052 7.18608 19.5001 7.66997 19.5001 7.99998V9.99998H18.5001V7.99998C18.5001 7.82999 18.445 7.56388 18.2943 7.35463C18.162 7.17088 17.9371 6.99998 17.5001 6.99998H13.7072L14.8536 8.14642L14.1465 8.85353L11.793 6.49998L14.1465 4.14642Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1465 20.8536L14.8536 20.1465L13.7072 19H17.5001C18.263 19 18.7881 18.6709 19.1058 18.2297C19.4052 17.8139 19.5001 17.33 19.5001 17V15H18.5001V17C18.5001 17.17 18.445 17.4361 18.2943 17.6454C18.162 17.8291 17.9371 18 17.5001 18H13.7072L14.8536 16.8536L14.1465 16.1465L11.793 18.5L14.1465 20.8536Z"
        fill={props.color}
      />
    </svg>
  );
};
